import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiGitMerge,
  DiHtml5,
  DiJava,
} from "react-icons/di";
import {
  SiPytorch,
  SiCss3,
  SiRedux
} from "react-icons/si";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava size={50}/><br/>
        <span className="purple">Java</span>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiHtml5 size={50}/><br/>
        <span className="purple">HTML</span>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCss3 size={50}/><br/>
        <span className="purple">CSS</span>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 size={50} /><br/>
        <span className="purple">Javascript</span>
      </Col>
      
      <Col xs={4} md={2} className="tech-icons">
        <DiReact size={50}/><br/>
        <span className="purple">ReactJS</span>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs size={50}/><br/>
        <span className="purple">nodeJS</span>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb size={50}/><br/>
        <span className="purple">MangoDB</span>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiRedux size={50}/><br/>
        <span className="purple">Redux</span>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGitMerge size={50}/><br/>
        <span className="purple">Git/Gitub</span>
      </Col>
    </Row>
  );
}

export default Techstack;
